export default __webpack_public_path__ + "static/slide-03-b8ea5645568d3619a5fd5c9d83d0da17.jpg";